import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function useWarehouseDetail(id) {
  return useSWR(
    !id
      ? null
      : {
          path: `/api/v1/warehouses/${id}`,
          method: "GET",
        },
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useWarehouseDetail;
